import { baseApi } from './baseApi';

export const userApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getCurrentUser: builder.query({
      query: () => ({
        url: `/users/current_user_info`,
      }),
      providesTags: ['User'],
    }),
    unsubscribeGoogle: builder.mutation({
      query: () => ({
        url: `/users/disconnect_google`,
        method: 'PATCH',
      }),
      invalidatesTags: ['User'],
    }),
    unsubscribeOutlook: builder.mutation({
      query: () => ({
        url: `/users/disconnect_outlook`,
        method: 'PATCH',
      }),
      invalidatesTags: ['User'],
    }),
    getUserProfile: builder.query({
      query: (userId) => ({
        url: `/user_profiles/${userId}`,
      }),
    }),
  }),
});

export const {
  useGetCurrentUserQuery,
  useUnsubscribeGoogleMutation,
  useUnsubscribeOutlookMutation,
  useGetUserProfileQuery,
} = userApi;
